"use client"

import { Button } from "@/components/ui/button"
import { ArrowRight, ChevronDown } from "lucide-react"
import Link from "next/link"
import { siteConfig } from "@/config/site"

export function HeroSection() {
  return (
    <section className="hero-section" aria-labelledby="hero-heading">
      <div className="hero-backdrop" aria-hidden>
        <div className="hero-backdrop--radial" />
        <div className="hero-backdrop--blob-left" />
        <div className="hero-backdrop--blob-right" />
      </div>

      <div className="hero-inner">
        <div className="hero-badge">
          
          <span>{siteConfig.slogan || "Тэгээс тэтгэлэгт тэнцэх нь"}</span>
        </div>

        <h1 id="hero-heading" className="hero-title">
          <span className="hero-title-line">{siteConfig.name || "MBG Education"}</span>
          <span className="hero-title-accent">
            {siteConfig.tagline || "Хятадын хэлийг эзэмших мэргэжлийн сургалт"}
          </span>
        </h1>

        <p className="hero-lede">
          {siteConfig.description || "Хятадын хэлийг эзэмших мэргэжлийн сургалт"}
        </p>

        <div className="hero-actions">
          <Button asChild variant="ghost" size="lg" className="btn-hero-primary">
            <Link href="/courses">Сургалтууд</Link>
          </Button>
          <Button asChild variant="ghost" size="lg" className="btn-hero-secondary">
            <Link href="/scholarship"  rel="noopener noreferrer">
              Тэтгэлэг
              <ArrowRight aria-hidden />
            </Link>
          </Button>
        </div>
      </div>

      <div className="hero-scroll" aria-hidden>
        <ChevronDown className="hero-scroll-icon" />
      </div>
    </section>
  )
}
